import axios from 'axios';
import config from '../../../config';
const state = {
    preferences: []
};

const getters = {
    getPreferencesByPreferenceKey: (state) => (preferenceKey) => {
        return state.preferences.find(preference => preference.preference_key === preferenceKey);
    },

    getPreferencesByPreferenceScope: (state) => (preferenceScope) => {
        return state.preferences.find(preference => preference.scope === preferenceScope);
    }
};

const mutations = {
    updatePreferences(state, data) {
        state.preferences = data;
    }
};

const actions = {
    async getPreferences(context) {
        const response = await axios.get(`${config.baseUrlForPreferencesService}/preferenceKeys`);
        context.commit('updatePreferences', response.data.body[0]);
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
